import { render, staticRenderFns } from "./vcd.vue?vue&type=template&id=1e131928&"
import script from "./vcd.vue?vue&type=script&lang=js&"
export * from "./vcd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports